import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  icon: {
    width: '20px',
    verticalAlign: 'middle',
    position: 'relative',
    bottom: '2px',
  },

  label: {
    color: theme.palette.text.primary,
    fontSize: '14px',
  },

  tooltipHotspot: {
    cursor: 'pointer',
  },

  tooltipPopup: {
    maxWidth: '450px',
  },

  useSystemNameContainer: {
    lineHeight: '32px',
  },
})
